export default "__VITE_ASSET__CjMSM4cT__"